import menuComponent from "@/components/menu/Menu.vue";
import footerComponent from "@/components/footer/Footer.vue";
export default {
  name: "firstConnectionProfile",
  data: function data() {
    return {
      loaded: false
    };
  },
  mounted: function mounted() {
    this.loaded = true;
  },
  components: {
    "menu-component": menuComponent,
    "footer-component": footerComponent
  }
};